import { Controller } from "stimulus"

export default class extends Controller {
  
  connect() {
    gtag('event', 'sign_up', {'method': "Website"})
  }
  
}